(function () {
  'use strict';

  const root = document.getElementById('Pdp-Cross-Sell-Section');
  if (!root) return;

  const prevBtn = root.querySelector('.Pdp-Cross-Sell-Chevron-Container.prev');
  const nextBtn = root.querySelector('.Pdp-Cross-Sell-Chevron-Container.next');
  const cards = root.querySelectorAll('.Pdp-Cross-Sell-Card');

  if (!prevBtn || !nextBtn || cards.length === 0) return;

  let currentIndex = 0;
  let maxVisible;

  function setMaxVisible() {
    if (window.innerWidth >= 320 && window.innerWidth <= 767) {
      maxVisible = 1;
    } else if (window.innerWidth >= 767 && window.innerWidth <= 1023) {
      maxVisible = 2;
    } else {
      maxVisible = 3;
    }
  }

  function removeDisableClass(element) {
    if (element.classList.contains('disable')) {
      element.classList.remove('disable');
    }
  }

  function addDisableClass(element) {
    if (!element.classList.contains('disable')) {
      element.classList.add('disable');
    }
  }

  function toggleDisableClass(index) {
    if (cards.length <= maxVisible) {
      addDisableClass(prevBtn);
      addDisableClass(nextBtn);
      return;
    }
    if (index === 0) {
      addDisableClass(prevBtn);
    } else {
      removeDisableClass(prevBtn);
    }
    if (index === cards.length - maxVisible) {
      addDisableClass(nextBtn);
    } else {
      removeDisableClass(nextBtn);
    }
  }

  function updateCardsDisplay() {
    cards.forEach((card) => (card.style.display = 'none'));
    for (let i = 0; i < maxVisible && i < cards.length; i++) {
      cards[i].style.display = 'flex';
    }
    currentIndex = 0;
    toggleDisableClass(currentIndex);
  }

  setMaxVisible();
  updateCardsDisplay();

  prevBtn.addEventListener('click', function () {
    if (currentIndex > 0) {
      cards[currentIndex + maxVisible - 1].style.display = 'none';
      currentIndex--;
      cards[currentIndex].style.display = 'flex';
      toggleDisableClass(currentIndex);
    }
  });

  nextBtn.addEventListener('click', function () {
    if (currentIndex < cards.length - maxVisible) {
      cards[currentIndex].style.display = 'none';
      currentIndex++;
      cards[currentIndex + maxVisible - 1].style.display = 'flex';
      toggleDisableClass(currentIndex);
    }
  });

  function updateResponsiveCrossSell() {
    setMaxVisible();
    updateCardsDisplay();

    const screenWidth = window.innerWidth;
    const headline = root.querySelector('.Pdp-Cross-Sell-Headline');
    if (!headline) return;

    if (screenWidth <= 1023) {
      headline.classList.remove('text-headline-m-desktop');
      headline.classList.add('text-headline-m-uppercase-mobile');
    } else {
      headline.classList.add('text-headline-m-desktop');
      headline.classList.remove('text-headline-m-uppercase-mobile');
    }
  }

  updateResponsiveCrossSell();
  window.addEventListener('resize', updateResponsiveCrossSell);
})();
